import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ ]

  connect() {
    console.log('Video controller connected to:', this.element.id)
  }

  toggle() {
    console.log('Video toggle called for:', this.element.id)
    const video = this.element

    if (video.style.position === 'fixed') {
      // Reset video styles
      video.style.position = ''
      video.style.zIndex = ''
      video.style.width = ''
      video.style.height = ''
      video.style.top = ''
      video.style.left = ''
      video.style.transform = ''
      
      // Pause the video when closing
      video.pause()
    } else {
      // Expand and center video
      video.style.position = 'fixed'
      video.style.zIndex = '999999999'
      video.style.transform = 'translate(-50%, -50%)'
      
      if (window.innerWidth > 768) {
        video.style.width = '80vw'
        video.style.height = '80vh'
        video.style.top = '50%'
        video.style.left = '50%'
      } else {
        video.style.width = '95vw'
        video.style.height = '60vh'
        video.style.top = '50%'
        video.style.left = '50%'
      }
      
      // Play the video when opening
      video.play()
    }
  }
}